import {_F} from "../../utility/func";
import maxBy = _F.maxBy;
import {resourceURL} from "../../utility/resourceURL";

export interface IBarChartCompactDataRow {
    description?: string;
    color: string;
    value: number;
}

export interface IBarChartCompactScope extends ng.IScope {
    togglePopover(row: IBarChartCompactDataRow);
    isPopoverOpen(row: IBarChartCompactDataRow) : boolean;
    areaInHectares(row: IBarChartCompactDataRow) : string;
    popoverTemplate(): string;
    altPopoverTemplate: string;
    popoverChipStyle(row: IBarChartCompactDataRow) : object;
    data : IBarChartCompactDataRow[];
    styleRow(row: IBarChartCompactDataRow) : object;
    rowTitle(row: IBarChartCompactDataRow) : string;
    maximum(): number;
}

export class BarChartCompact implements ng.IDirective {
    restrict = 'E'; //attribute or element
    transclude = true;
    replace = true;
    // noinspection JSUnusedGlobalSymbols
    elementClass = 'lt-bar-chart-compact lt-vis';
    template =
        `<div class="lt-bar-chart-compact lt-vis">
            <ul class="lt-bar-chart-compact-rows">
                <li ng-repeat="row in data"
                    role="button"
                    ng-attr-title="{{rowTitle(row)}}"
                    ng-attr-aria-label="{{rowTitle(row)}}"
                    uib-popover-template="popoverTemplate()"
                    popover-is-open="isPopoverOpen(row)"
                    ng-click="togglePopover(row)">
                    <div class="bar-chart-row-inner" ng-style="styleRow(row)"></div>
                </li>
            </ul>                        
            <div class="magnitude-axis d-flex">
                <span>0</span>
                <span class="flex-1 text-center">Area (ha)</span>
                <span class="text-right">{{ maximum() | number:0 }}</span>
            </div>
        </div>`;
    scope = {
        name: '=',
        data: '='
    };
    constructor() {
        this.link = ($scope: IBarChartCompactScope, element: ng.IAugmentedJQuery,
                     attrs: ng.IAttributes) => {
            let getMax = () => maxBy($scope.data, d => d.value);
            $scope.styleRow = (row) => {
                let max = getMax() || 100;
                return {
                    width: `${100 * row.value / max}%`,
                    background: row.color
                }
            };

            $scope.areaInHectares = (row) => {
                return _F.numberFormat(_F.getHectaresRounded(row.value)) + ' ha';
                // return `${Math.round(row.value / 10000)}ha`;
            };

            // Only allow one popover to be opened at a time
            let rowPopoverIsOpenedFor : IBarChartCompactDataRow = null;

            $scope.togglePopover = (row) => {
                if (rowPopoverIsOpenedFor == row) {
                    rowPopoverIsOpenedFor = null;
                } else {
                    rowPopoverIsOpenedFor = row;
                }
            };

            $scope.isPopoverOpen = (row) => {
                return row == rowPopoverIsOpenedFor;
            };

            $scope.rowTitle = (row) => {
                return `${row.description ? row.description + ' - ' : ''}${$scope.areaInHectares(row)}`;
            };

            $scope.maximum = () => Math.round(getMax() / (100 * 100));

            $scope.popoverChipStyle = (row) => {
               return {
                    'background': row.color
               };
           };

            $scope.popoverTemplate = () => {
                return $scope.altPopoverTemplate || resourceURL('/app-page/javascript/public/partials/bcc-popover.html');
            };
        };
    }

    link: ($scope: ng.IScope, elem: ng.IAugmentedJQuery,
           attrs: ng.IAttributes) => void = null;

    static factory(): ng.IDirectiveFactory {
        const directive = () => new BarChartCompact();
        directive.$inject = [];
        return directive;
    }
}